import _ from "lodash";
import {
  useTheme,
  useMediaQuery,
  Box,
  IconButton,
  Typography,
} from "@mui/material";
import { UpdateRounded, ClearAllRounded } from "@mui/icons-material";
import { DefaultSettings } from ".";
import TagsSortKeySelect from "./TagsSortKeySelect";
import { PerPageSwitcher } from "../general";
import { TagCreationButton } from "../../general";

const TagsTopBar = (props) => {
  const {
    tagsNumOfResults,
    reload,
    settings,
    resetSettings,
    onSuccessfulCreation,
    ...otherProps
  } = props;

  const theme = useTheme();
  const matchesDownSm = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        gap: { xs: 1, md: 0 },
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
        }}
      >
        <Typography
          component="div"
          sx={{
            fontSize: "24px",
            fontWeight: "bold",
          }}
        >
          Results: {tagsNumOfResults}
        </Typography>
        <Box sx={{ display: "flex" }}>
          <IconButton onClick={reload}>
            <UpdateRounded />
          </IconButton>
          {!_.isEqual(settings, DefaultSettings) && (
            <IconButton onClick={resetSettings}>
              <ClearAllRounded />
            </IconButton>
          )}
          {matchesDownSm && (
            <TagCreationButton onSuccess={onSuccessfulCreation} />
          )}
        </Box>
      </Box>
      <Box sx={{ marginLeft: { sm: "auto" } }}>
        <TagsTopBarFilters
          settings={settings}
          onSuccessfulCreation={onSuccessfulCreation}
          showCreationButton={!matchesDownSm}
          {...otherProps}
        />
      </Box>
    </Box>
  );
};

const TagsTopBarFilters = ({ settings, setMethods, onSuccessfulCreation, showCreationButton = true }) => {
  const { perPage, sortKey } = settings;

  const { setPerPage, setSortKey } = setMethods;

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
      }}
    >
      {showCreationButton && (
        <TagCreationButton onSuccess={onSuccessfulCreation} />
      )}
      <TagsSortKeySelect sortKey={sortKey} setSortKey={setSortKey} />
      <PerPageSwitcher
        perPage={perPage}
        setPerPage={setPerPage}
        fixedMinWidth={true}
      />
    </Box>
  );
};

export default TagsTopBar;
